import React, {Fragment, useContext, useEffect} from "react";
import "react-datepicker/dist/react-datepicker.css";
import 'react-loading-skeleton/dist/skeleton.css'
import {Card, ListGroup} from "react-bootstrap";
import {TsAdminContext} from "../../context/ts-admin";
import {QrCodeReader} from "../qr-setting/qr-code-reader";


export function ExportQrCodePage() {
    const [orgInfo] = useContext(TsAdminContext);
    const pageTitle = "QRコード発行";
    useEffect(() => {
        if (orgInfo && orgInfo.permissionsModifyAllData) {
            window.location.href = '404'
        }
    }, [orgInfo]);
    return (
        <Fragment>

            {
                orgInfo &&
                <div className="provider-settings qr-settings">
                    <Card className="mt-3 card-container">
                        <Card.Body className="page-title">{pageTitle}</Card.Body>
                    </Card>


                    <Card className="mt-3 card-container">
                        <ListGroup variant="flush">
                            <ListGroup.Item className="d-flex align-items-center">
                                <div className="w-25 py-2 item-label">QRコード</div>
                                <div key="inline-radio" className="w-50">
                                    <div className='w-100'>
                                        {
                                            orgInfo && <QrCodeReader/>
                                        }
                                    </div>
                                </div>
                            </ListGroup.Item>
                        </ListGroup>

                    </Card>


                </div>
            }
        </Fragment>
    )

}